import Staking_1 from "../../../static/assets/images/wealth/Staking_1.svg";
import Doubleapy from "../../../static/assets/images/wealth/Doubleapy.svg";
import Stablecoins from "../../../static/assets/images/wealth/Lend-Stablecoins.svg";


export const cardItemsWealth = [
    {
        id: "stake",
        title: "Stake",
        text: "Earn passive income by staking your favorite crypto assets on the Changex hub.”",
        src: Staking_1,
        alt: "Investment Slider image for stake",
        linkText: "Coming Soon",
        route: false,
        url: "hero"
    },
    {
        id: "apy",
        title: "Double APR",
        text: "Amplify staking rewards with state-of-the-art Leveraged Staking products for assets like HYDRA and Ethereum.",
        src: Doubleapy,
        alt: "Investment Slider image for Double APR",
        linkText: "Coming Soo.",
        route: true,
        url: "/wealth"
    },
    {
        id: "stablecoins",
        title: "Earn Stablecoins",
        text: "Deposit idle stablecoin assets into an “Earn” feature for a fixed interest rate to seamleslly earn stablecoins.",
        src: Stablecoins,
        alt: "Investment Slider image for Earn Stablecoins",
        linkText: "Coming Soon",
        route: true,
        url: "/wealth"
    }
]

export const stake = {
    id: "Tab 1",
    alt: "Investment Slider image for stake",
    text: "Earn passive income by staking your favorite crypto assets on the Changex hub.”"
}

export const doubleApy = {
    id: "Tab 2",
    alt: "Investment Slider image for Double APR",
    text: "Amplify staking rewards with state of the art Leveraged Staking products for assets like HYDRA and Ethereum."
}

export const stablecoins = {
    id: "Tab 3",
    alt: "Investment Slider image for Earn Stablecoins",
    text: "Deposit idle stablecoin assets into an “Earn” feature for a fixed interest rate to seamleslly earn stablecoins."
}

export const sliderDataLandingPage = [
    {
        id: "Tab1",
        src: "/assets/images/wealth/Benefits_Black.svg",
        title: "Stake",
        alt: "Investment Slider image for stake",
        text: "Earn passive income by staking your favorite crypto assets on the Changex hub.”",
        linkText: "",
        route: false,
        url: "#"
    },
    {
        id: "Tab2",
        src: "/assets/images/wealth/LeveragedStakingBlack.svg",
        title: "Double APR",
        alt: "Investment Slider image for Double APR",
        text: "Amplify staking rewards with state-of-the-art Leveraged Staking products for assets like HYDRA and Ethereum.",
        linkText: "",
        route: false,
        url: "#"
    },
    {
        id: "Tab3",
        src: "/assets/images/wealth/Stablecoins.svg",
        title: "Earn Stablecoins",
        alt: "Investment Slider image for Earn Stablecoins",
        text: "Deposit idle stablecoin assets into an “Earn” feature for a fixed interest rate to seamleslly earn stablecoins.",
        linkText: "",
        route: false,
        url: "#"
    }
]

export const cardDataWealthPage = [
    {
        id: "card1",
        src: "/assets/images/wealth/StakingWealth.svg",
        title: "Flexible Staking",
        alt: "Flexible Staking",
        text: "Stake assets and maintain immediate access to them without interrupting the flow of rewards. This is a unique way to use your crypto in various ways while earning on it constantly.",
        linkText: "",
        route: true,
        url: "#"
    },
    {
        id: "card2",
        src: "/assets/images/wealth/Hydra.svg",
        title: "Leveraged Staking",
        alt: "Leveraged Staking",
        text: "Changex will offer state-of-the-art Leveraged Staking products for Ethereum and Hydra that will enable users to significantly increase APR with under 5 taps.",
        linkText: "",
        route: false,
        url: "#"
    },
    {
        id: "card3",
        src: "/assets/images/wealth/WealthChange.svg",
        title: "Stablecoin Savings Product",
        alt: "Stablecoin Savings Product",
        text: "Changex will provide its users the ability to deposit idle stablecoin assets into an “Earn” feature for a fixed interest rate.",
        linkText: "",
        route: true,
        url: "#"
    }
]


/*WEALTH PAGE items */

export const heroObj = {
    titleObj: {
        h1: "Boost your income with Defi",
        h2: "Earn Passive Income",
        h3: "Access a powerful suite of DeFi investment and passive income products and take control of your financial future.",
    },
    text: "",
    appBtnsVisible: false,
    scrollBtnText: "Boost Income",
    scrollToID: "changex_slider",
    backgroundImage: "/assets/images/wealth/Wealth_Center_Desktop.webp",
    class: "hero-wealth"
};

export const textData = {
    background: "background-color-black",
    head: "",
    h1: "Start",
    h2: "Staking",
    h3: "Don't just hold your crypto - stake it and earn on your investments passively, while retaining access to your coins.",
    h4: "",
    button: true,
    buttonTxt: "Stake CHANGE",
    buttonUrl: "https://hydradex.org/#/swap",
};

export const featureContent = {
    head: "More Features Coming Soon",
    feature: [
        {
            h1: "HYDRA",
            h2: "Leveraged Staking",
            h3: "By selling LYDRA for HYDRA and re-staking the HYDRA, stakers can achieve a boosted staking APR.",
            h4: "",
            route: 'false',
            buttonTxt: "Learn More",
            buttonUrl: "https://blog.changex.io/2023/01/17/45/",
            buttonClass: "button-lime",
            imageUrl: "/assets/images/wealth/leverage_staking.svg",
            imageClass: "centerImage",
            alignImage: "right",
            commingSoon: false,
            offerText: "",
            bottomText: "",
        },
        // {
        //     h1: "Discover",
        //     h2: "Lending",
        //     h3: "Earn on stablecoins like USDT and USDC while powering the Leveraged Staking economy. ",
        //     h4: "Users who use leveraged staking borrow your stablecoins to acquire more of their asset, and pay you back the interest. Everything is completely decentralized, and your coins play a vital role in the ecosystem.",
        //     buttonTxt: "Read Whitepaper",
        //     route: false,
        //     buttonUrl:
        //         "https://whitepaper.changex.io/",
        //     buttonClass: "button-lime",
        //     imageUrl: "/assets/images/wealth/lending.svg",
        //     imageClass: "centerImage",
        //     alignImage: "left",
        //     commingSoon: false,
        //     offerText: "",
        //     bottomText: "",
        // },
    ],
};

export const featureContent2 = {
    feature: [
        {
            h1: "Stack For A Rainy Day With",
            h2: "Savings",
            h3: "Changex will provide its users the ability to deposit idle stablecoin assets into an “Earn” feature for a fixed interest rate.",
            h4: "",
            buttonTxt: "Read Whitepaper",
            route: false,
            buttonUrl:
                "https://whitepaper.changex.io/",
            buttonClass: "button-blue",
            imageUrl: "/assets/images/savings/Savings_Rainy_Day.webp",
            imageClass: "centerImage",
            alignImage: "right",
            commingSoon: true,
            offerText: "Coming Soon",
            bottomText: "",
        },
    ],
    info: "The savings mechanism automatically distributes the deposited funds into DeFi products that offer appealing liquidity mining and inflationary mechanisms for stimulating growth."
};

export const textDataWealthSection = {
    background: "background-color-black",
    head: "Invest",
    h1: "Invest Responsibly,",
    h2: " Thrive Sustainably!",
    h3: "Generate passive income with DeFi’s most powerful investment tools and get rewarded for investing in ESG projects.",
    button: true,
    route: true,
    buttonTxt: "Boost Income",
    buttonUrl: "/wealth"
};
